import React, { useState, useRef, useEffect } from 'react';

// Reusable type-ahead: start typing a name/client#/phone, list narrows as
// you go, click a match to select. Used anywhere a page previously used a
// long <select> of every customer (LoanForm has its own inline version
// since that file isn't JSX; this is for JSX pages like Income.js).
export default function CustomerAutocomplete({ customers, selectedLabel, onSelect, onClear, placeholder, inputStyle }) {
  const [text, setText] = useState(selectedLabel || '');
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => { setText(selectedLabel || ''); }, [selectedLabel]);

  const q = text.trim().toLowerCase();
  const matches = q === '' ? [] : customers.filter(c =>
    (c.name && c.name.toLowerCase().includes(q)) ||
    (c.client_number && String(c.client_number).toLowerCase().includes(q)) ||
    (c.phone1 && c.phone1.includes(q))
  ).slice(0, 15);

  const handleChange = (val) => {
    setText(val);
    setOpen(true);
    if (val === '' && onClear) onClear();
  };

  const handleSelect = (c) => {
    setText(c.name);
    setOpen(false);
    onSelect(c);
  };

  return (
    <div ref={boxRef} style={{ position: 'relative' }}>
      <input
        type="text"
        value={text}
        placeholder={placeholder || 'Type a name...'}
        onChange={e => handleChange(e.target.value)}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        style={inputStyle || { padding: '5px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, width: 180 }}
      />
      {open && q !== '' && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 30, background: 'white', border: '1px solid #d1d5db', borderRadius: 6, marginTop: 2, maxHeight: 220, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.12)' }}>
          {matches.length === 0
            ? <div style={{ padding: 10, color: '#6b7280', fontSize: 12 }}>No matches</div>
            : matches.map(c => (
                <div
                  key={c.id}
                  onMouseDown={e => { e.preventDefault(); handleSelect(c); }}
                  style={{ padding: '8px 10px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13 }}
                >
                  <div style={{ fontWeight: 600 }}>{c.name}</div>
                  <div style={{ fontSize: 11, color: '#6b7280' }}>#{c.client_number} | {c.phone1}</div>
                </div>
              ))}
        </div>
      )}
    </div>
  );
}
